import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_mst_attribute_set_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.TextDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  data_source_type: fromDatatype.TextDatatypeInterface;
  data_source_logic: fromDatatype.TextDatatypeInterface;
  label_hdr_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_fi_mst_attribute_set_hdr_RowClass
  implements bl_fi_mst_attribute_set_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    name: fromDatatype.TextDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    data_source_type: fromDatatype.TextDatatypeInterface;
    data_source_logic: fromDatatype.TextDatatypeInterface;
    label_hdr_guid: fromDatatype.GuidDataFieldInterface;
}
